"use client";
import { useEffect, useRef } from "react";
import { useTranslations } from 'next-intl';
import Party3rd from "./3rdParty";
import ClientsTestimonials from "./ClientsTestimonials";

export default function Testimonials() {
  const t = useTranslations('Home');
  const subRef = useRef<HTMLParagraphElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    import("gsap").then(({ gsap }) => {
      const tl = gsap.timeline();
      tl
        .from(subRef.current, {
          opacity: 0,
          y: 30,
          duration: 1,
        }, "-=0.5")
        .from(buttonRef.current, {
          opacity: 0,
          y: 20,
          duration: 1,
        }, "-=0.5");
    })
  }, []);



  return (
    <section className="relative bg-gradient-dark min-h-screen text-white pt-14" style={{ contentVisibility: 'auto' }}>
      <section className="relative w-full h-auto flex items-center justify-center overflow-hidden  text-white pt-14" style={{ contentVisibility: 'auto' }}>
        <div className="relative z-10 text-center">
          <div className="flex justify-end mt-0 md:-mt-14">
            <p ref={subRef} className="text-sm md:text-2xl lg:text-4xl mb-6 text-start">
              {t('affiliates')}
            </p>
          </div>
        </div>
      </section>
      <Party3rd />
      <section className="relative w-full h-auto flex items-center justify-center overflow-hidden  text-white mt-40 pt-14" style={{ contentVisibility: 'auto' }}>
        <div className="relative z-10 text-center">
          <div className="flex justify-end mt-0 md:-mt-14">
            <p ref={subRef} className="text-sm md:text-2xl lg:text-4xl mb-6 text-start">
              {t('testimonials')}
            </p>
          </div>
        </div>
      </section>
      <ClientsTestimonials />
    </section>
  );
}
